import React, { useEffect, useState }  from 'react';
import { CardMedia } from '@mui/material'
import useImageProfessional from 'src/Professional/hooks/useImageProfessional';
// import { useSetRecoilState } from 'recoil';
// import { imageProfessionalState, showMoldalImageProfessionalState } from './state/atoms';

const ProfessionalImagenologia = ({
    width = 82,
    height = 120,
    widthIconHeader = 32,
    heightIconHeader = 32,
    image,
    alt,
    rut
}) => {

    const { loadImageProfessional } = useImageProfessional();

    const [imagenImg, setImagenImg] = useState();

    useEffect(() => {
        let url = "";

        url = loadImageProfessional(rut);
        setImagenImg(url);

    }, [])

    return (
        <div>
            <CardMedia
                style={{ borderRadius: 5, position: 'sticky' }}
                component="img"
                image={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/icon_medico.png`}
                alt="icono_medico"
                sx={{
                    height: heightIconHeader,
                    width: widthIconHeader
                }}
            />

            <CardMedia
                style={{ borderRadius: 5 }}
                component="img"
                image={imagenImg}
                alt={alt}
                sx={{
                    marginTop: `-${heightIconHeader}px`,
                    height: height,
                    width: width
                }}
            />
        </div>
    )
}

export default ProfessionalImagenologia
